import React from "react"
import { graphql } from "gatsby"

import { QueryFragments } from "../GraphQl/queryFragments"

import { BlogCard } from "../components/blog/blogCard"
import { BlogBanner } from "../components/blog/blogBanner"
import { BlogNav } from "../components/blog/blogNav"

const BlogPortal = ({ data: { posts } }) => {
  return (
    <>
      <BlogBanner />
      <div className="grid grid-cols-14 mb-32 mt-16">
        <BlogNav />
        <div className="col-start-2 col-end-14 md:col-start-3 md:col-end-13 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-16">
          {posts && posts.edges.map(item => <BlogCard {...item.node} />)}
        </div>
      </div>
    </>
  )
}

export default BlogPortal

export const pageQuery = graphql`
  query blogPortalQuery($skip: Int!, $limit: Int!) {
    posts: allSanityPost(skip: $skip, limit: $limit) {
      edges {
        node {
          ...BlogCardFields
        }
      }
    }
  }
`
